import * as t from 'io-ts';
import { id, meta, numberOrNull, stringOrNull } from '@/services/api';

const breadcrumb = t.type({
  header: t.string,
  title: t.string,
  type: t.string,
  uuid: t.string,
});

export const dataCodec = t.intersection([
  t.type({
    assetId: t.string,
    validationResult: t.union([t.boolean, t.null]),
    validationConfidence: numberOrNull,
    validationCriteria: stringOrNull,
    validationDescription: stringOrNull,
    imageDescription: stringOrNull,
    createdAt: numberOrNull,
    responseId: t.string,
    inspectionId: t.number,
    inspectionTitle: t.string,
    inspectionConductedAt: t.number,
    inspectorId: t.number,
    entityItemId: numberOrNull,
    submitterId: t.number,
    submitterName: t.string,
    entityName: stringOrNull,
    questionTitle: t.string,
    originalCriteria: stringOrNull,
  }),
  t.partial({
    breadcrumb: t.array(breadcrumb),
  }),
]);

export const recordCodec = t.type({
  id,
  data: dataCodec,
});

export const listCodec = t.type({
  data: t.array(recordCodec),
  meta,
});

const adjacentIdsCodec = t.type({
  previous_id: numberOrNull,
  next_id: numberOrNull,
});

const metaCodec = t.type({
  adjacentIds: adjacentIdsCodec,
});

export const detailCodec = t.intersection([
  recordCodec,
  t.type({
    meta: metaCodec,
  }),
]);
